import React from 'react';
import { Button, Col, Modal, Row, Spinner } from 'react-bootstrap';
import OtpWithTimer from '../otpWithTimer/otpWithTimer';
import OTPIcon from '../../../assets/images/otp-icon.png';

type Props = {
  show: boolean;
  isLoading: boolean;
  handleClose: () => void;
  modalTitle: string;
  modalMessage?: string;
  modalSubmitBtnText?: string;
  resendHandler?: () => void;
  onSubmit?: () => void;
  otpChangeHandler: (value: string) => void;
  enableResendTimer: boolean;
  isDisabled?: boolean;
  resendButtonText?: string;
  otpLabel?: string;
  ackMessage?: string;
  ackMessageType?: 'success' | 'fail';
  otpValue: string;
  resendInterval: number;
  numInputs: number;
};

const OtpPopup = ({
  show,
  isLoading,
  handleClose,
  modalTitle,
  modalMessage,
  modalSubmitBtnText,
  onSubmit,
  isDisabled = false,
  otpValue,
  numInputs,
  ackMessage,
  ackMessageType,
  ...otpProps
}: Props) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop='static'
      keyboard={false}
      dialogClassName='otp__modal-width'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <div className='my-3'>{modalMessage}</div>
        </Row>
        <Row>
          <Col md={8}>
            <OtpWithTimer
              otpValue={otpValue}
              numInputs={numInputs}
              ackMessage={ackMessage}
              ackMessageType={ackMessageType}
              isDisabled={ackMessage && ackMessageType == 'success'}
              {...otpProps}
            ></OtpWithTimer>
          </Col>
          <Col md={4}>
            <img
              src={OTPIcon}
              alt=''
              className='user-select-none'
              width={160}
            />
          </Col>
        </Row>
      </Modal.Body>

      {ackMessage && ackMessageType == 'success' ? null : (
        <Modal.Footer>
          <Button
            variant='secondary'
            disabled={isLoading}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant='primary'
            disabled={otpValue?.length !== numInputs || isLoading}
            onClick={onSubmit}
          >
            {modalSubmitBtnText}{' '}
            {isLoading ? <Spinner animation='border' size='sm' /> : null}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default OtpPopup;
